import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=23b4b388&"
import script from "./LoginDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports